export default "__VITE_ASSET__BxG3ZBW1__"